import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { fetchPurchasePackageThunks } from "./purchasePackageThunks";

export const initialPurchasePackageState = {
    packages: [],
    isLoading: false,
    error: {
        isError: false,
        message: ''
    }
}

export class PurchasePackageDto {
    constructor(data) {
        this.packageName = data?.PackageName || '';
        this.packageId = data?.PackageId || '';
        this.orderId = data?.OrderGId || '';
        this.assessmentCount = data?.AssessmentCount || 0;
        this.noOfComplete = data?.NoOfComplete || 0;
        this.noOfInProgress = data?.NoOfInprogress || 0;
        this.expireDate = data?.ExpireDate || Date.now();
        this.assessmentTaken = data?.AssessmentTaken || 0;
        this.balance = data?.Balance || 0;
        this.isExpired = data?.IsExpiry || false;
    }
}


const purchasePackageSlice = createSlice({
    initialState: initialPurchasePackageState,
    name: 'purchasePackage',
    reducers: {
        // setPackages(state, action) {
        //     const packages = action.payload;
        //     state.packages = packages.map(pak => new PurchasePackageDto(pak));
        // },
        // clearPackages(state) {
        //     state.packages = [];
        // },
        // reducePackageQuantity(state, action) {
        //     const { packageId } = action.payload;
        //     const packageIndex = state.packages.findIndex(pak => pak.packageId === packageId);
        //     if(packageIndex === -1) {
        //         toast.error("Package ID Not Found");
        //     }
        //
        //     const packageItem = state.packages[packageIndex];
        //     if(packageItem.balance <= 0) {
        //         toast.error("No Assessment Available");
        //     }
        //     if(packageItem.isExpiry) {
        //         toast.error("Package Expired");
        //     }
        //
        //     state.packages = state.packages.map((pak, index) => {
        //         if (index === packageIndex) {
        //             return {
        //                 ...pak,
        //                 balance: pak.balance - 1,
        //                 assessmentTaken: pak.assessmentTaken + 1,
        //             };
        //         }
        //         return pak;
        //     });
        // }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPurchasePackageThunks.pending, (state) => {
                state.isLoading = true;
                state.error = {
                    isError: false,
                    message: ''
                }
            })
            .addCase(fetchPurchasePackageThunks.fulfilled, (state, action) => {
                state.isLoading = false;
                state.packages = action.payload.map(pak => new PurchasePackageDto(pak))


            })
            .addCase(fetchPurchasePackageThunks.rejected, (state) => {
                state.isLoading = false;
                toast.error("Internal Server Error");
                state.error = {
                    isError: true,
                    message: 'Internal Server Error'
                }
            })
    }

})

// export const { setPackages, clearPackages, reducePackageQuantity } = purchasePackageSlice.actions;
export default purchasePackageSlice.reducer;
